import InstalationModel from '../models/InstalationModel';
import IService from './IService';
import Axios from 'axios';

export default class InstalationService implements IService<InstalationModel> {

    constructor() {
    }

    async getmapadata(filter: any) {
        const data = [];
        var res = await Axios.post('/api/instalations/getmapdata', filter)
        .then(res => {
            if (res.data.success) {
                let obj = {
                    defaultPoint: res.data.defaultPoint,
                    districtPoint: res.data.districtPoint,
                    provincePoint: res.data.provincePoint,
                    statesPoint: res.data.statesPoint,
                    data: res.data.data.map((itm: any) => {
                        let ret = new InstalationModel();
                        ret.idNInstalacion = itm.idNInstalacion;
                        ret.fkNEmpresa = itm.fkNEmpresa;
                        ret.fkNMunicipio = itm.fkNMunicipio;
                        ret.fldTCodigo = itm.fldTCodigo;
                        ret.fldTNombre = itm.fldTNombre;
                        ret.fldTDireccion = itm.fldTDireccion;
                        ret.fldTCP = itm.fldTCP;
                        ret.fldTTelefono = itm.fldTTelefono;
                        ret.fldDAlta = itm.fldDAlta;
                        ret.fldDBaja = itm.fldDBaja;
                        ret.fkNIcono = itm.fkNIcono;
                        ret.fkNGestor = itm.fkNGestor;
                        ret.fkNTecnico = itm.fkNTecnico;
                        ret.fkNJefeZona = itm.fkNJefeZona;
                        ret.fkNEjecutivo = itm.fkNEjecutivo;
                        ret.fldDApertura = itm.fldDApertura;
                        ret.fldDCierre = itm.fldDCierre;
                        ret.fldNLongitud = itm.fldNLongitud;
                        ret.fldNLatitud = itm.fldNLatitud;
                        ret.fldNEstado = itm.fldNEstado;
                        ret.fldDUltimaTransmisionRecibida = itm.fldDUltimaTransmisionRecibida;
                        ret.elementos = itm.elementos;

                        return ret;
                    })
                };
                let result = {
                    success: true,
                    data: obj
                }
                return result;
            }
            return null;
        }).catch(error => {
            let result = {
                success: false,
                Message: error.response.data.responseErrorMessage
            }
            return result;
        });
        return res;
    }

    async list(filter: any) {
        const data = [];
        var res = await Axios.post('/api/instalations/list', filter)
        .then(res => {
            if (res.data.success) {
                let obj = res.data.data.map((itm: any) => {
                        let ret = new InstalationModel();
                        ret.idNInstalacion = itm.idNInstalacion;
                        ret.fkNEmpresa = itm.fkNEmpresa;
                        ret.fkNMunicipio = itm.fkNMunicipio;
                        ret.fldTCodigo = itm.fldTCodigo;
                        ret.fldTNombre = itm.fldTCodigo + ' ' + itm.fldTNombre;
                        ret.fldTDireccion = itm.fldTDireccion;
                        ret.fldTCP = itm.fldTCP;
                        ret.fldTTelefono = itm.fldTTelefono;
                        ret.fldDAlta = itm.fldDAlta;
                        ret.fldDBaja = itm.fldDBaja;
                        ret.fkNIcono = itm.fkNIcono;
                        ret.fkNGestor = itm.fkNGestor;
                        ret.fkNTecnico = itm.fkNTecnico;
                        ret.fkNJefeZona = itm.fkNJefeZona;
                        ret.fkNEjecutivo = itm.fkNEjecutivo;
                        ret.fldDApertura = itm.fldDApertura;
                        ret.fldDCierre = itm.fldDCierre;
                        ret.fldNLongitud = itm.fldNLongitud;
                        ret.fldNLatitud = itm.fldNLatitud;
                        ret.fldNEstado = itm.fldNEstado;
                        ret.fldDUltimaTransmisionRecibida = itm.fldDUltimaTransmisionRecibida;
                        ret.elementos = itm.elementos;

                        return ret;
                    })
                let result = {
                    success: true,
                    data: obj
                }
                return result;
            }
            return null;
        }).catch(error => {
            let result = {
                success: false,
                Message: error.response.data.responseErrorMessage
            }
            return result;
        });
        return res;
    }

    async insert(data: InstalationModel) {
        var res = await Axios.post('/api/Instalations/insert', data);
        return res.data;
    }

    async update(data: InstalationModel) {
        var res = await Axios.put('/api/Instalations/update', data);
        return res.data;
    }

    async delete(data: InstalationModel) {
        var res = await Axios.delete('/api/Instalations/delete?id=' + data.idNInstalacion);
        return res.data;
    }

    async export(filter: any) {
        var res = await Axios.post('/api/Instalations/export', filter, {
            responseType: 'blob'
        });
        return res.data;
    }

    async get(idInstalacion: number, idElemento: any) {
        var res = await Axios.get('/api/instalations/get', {
            params: {
                idInstalacion: idInstalacion,
                idElemento: idElemento
            }
        });
        return res.data;
    }

    async getDescriptions(id: number) {
        var res = await Axios.get('/api/instalations/getdescriptions', {
            params: {
                id: id
            }
        });
        return res.data;
    }
    async getInstalation(id: number) {
        var res = await Axios.get('/api/instalations/getinstalation', {
            params: {
                id: id
            }
        });
        return res.data;
    }
}